module.exports = __webpack_public_path__ + "static/img/VIKING.0671852.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/VIKING.png
// module id = fhbT
// module chunks = 0